import {
    Entry,
    ListRequest,
    ListResponse,
} from "../../../generated/protocol";
import { injectable } from "inversify";
import { AbstractAdminEntityService } from "./AbstractAdminEntityService";

@injectable()
export class TransactionHistoryService extends AbstractAdminEntityService<Entry, TransactionHistoryResponse> {

    constructor() {
        super("/wallet/transactions");
    }


    list(listRequest: TransactionHistoryRequest): Promise<TransactionHistoryResponse> {
        const date = listRequest.fromDate || 0;
        const listRequestPath = this.entityPath +
            "/" + listRequest.userId +
            "/" + listRequest.accountType +
            "?limit=" + listRequest.limit +
            "&offset=" + listRequest.offset +
            "&fromDate=" + date

        return this.http
            .doGet<TransactionHistoryResponse>(listRequestPath)
            .then(r => ({
                items: r.transactions.map(t => ({ ...t, currencyCode: accountTypeToCurrency(t.accountType) })),
                nrOfResults: r.totalResultsCount
            }));
    }
}

function accountTypeToCurrency(currencyCode: string): string {
    switch (currencyCode) {
        case "sc-main":
            return "XSD"
        case "gc-main":
            return "XGC"
        case "sc-vault":
            return "VAULT-SC"
        case "gc-vault":
            return "VAULT-GC"
        default:
            return ""
    }
}

export interface PlayerHistoricTransaction {
    userId: number;
    accountType: string;
    amount: string;
    balance: string;
    timestamp: string;
    privateComment: string;
    publicComment: string;
    transactionDomain: string;
    externalId?: string;
    currencyCode: string;
    metadata: string;
}

export interface TransactionHistoryRequest extends ListRequest {
    accountType: string;
    userId: string;
    fromDate: number;
}

export interface TransactionHistoryResponse extends ListResponse {
    transactions?: PlayerHistoricTransaction[];
    items?: PlayerHistoricTransaction[];
    totalResultsCount?: number;
}



// WEBPACK FOOTER //
// ./src/app/service/admin/TransactionHistoryService.ts